var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPhoneUI)?_c('div',{attrs:{"id":"phone-ui"}},[_c('div',{ref:"audioContainer"}),_c('div',{class:_vm.callBoxClass},[_c('PhoneStatus'),_c('PhoneButtons')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }